import React from 'react';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { BAOVELUANANCOSO_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';
import { trangThaiBaoVeCoSoValue } from '../../../../utils/define';

const schema = yup.object().shape({
    ngayBaoVe: yup.string().required('Vui lòng chọn ngày bảo vệ dự kiến')
});

const BaoVeCoSoAdd = ({ hoSoId, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) => Post(BAOVELUANANCOSO_API.ADD_ITEM, null, value, false));

    const handleCreate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            NgayBaoVe: values.ngayBaoVe || null,
            TrangThai: trangThaiBaoVeCoSoValue.choQuyetDinh
        };

        addFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.success)) {
                    toast.success('Thêm mới thành công');
                    queryClient.invalidateQueries(['baoVeCoSoData', hoSoId]);
                    queryClient.invalidateQueries(['duyetBaoVeCoSoData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Thêm mới đợt bảo vệ cơ sở</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleCreate}
                    initialValues={{
                        ngayBaoVe: ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Ngày bảo vệ dự kiến <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayBaoVe"
                                            value={values.ngayBaoVe}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.ngayBaoVe && !!errors.ngayBaoVe && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.ngayBaoVe}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            
                            <div className="text-right mt-3">
                                <Button variant="secondary" onClick={() => setViewMode('list')} className="mr-2" disabled={isSubmitting}>
                                    Hủy
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Đang lưu...' : 'Thêm'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default BaoVeCoSoAdd;
